import _ from "lodash";

const parseJsonString = (dataStr, defaultValue = null) => {
  try {
    // Use the decoded value only if it's not falsy
    const parsed = JSON.parse(dataStr);
    if (parsed) return parsed;
  } catch (e) {
    // Log any failures to the lowest priority pipe
    console.debug(e);
  }

  return defaultValue;
};

const isDisplayable = (value) => {
  const valueIsEmpty =
    (value instanceof Array || value instanceof Object) && _.isEmpty(value);
  return (
    value !== null &&
    value !== "" &&
    typeof value !== "undefined" &&
    !valueIsEmpty
  );
};

const isTruthyOrZero = (value) => {
  return value || value === 0 || value === "0";
};

const isLgLocationById = (rawId) => {
  if (!rawId) return false;
  const id = parseJsonString(rawId);
  return _.get(id, "type") === "localgraf";
};

const lgLocationIdParts = (id) => {
  if (!id) return;
  return parseJsonString(id);
};

const formatName = (name) => {
  return name && name.slice(1, -1);
};

const parseName = (name) => {
  return name && `%${name}%`;
};

const convertNum = (val) => {
  const convertedNum = Number(val);
  if (val === null || val === "") {
    return null;
  } else if (!_.isFinite(convertedNum) || val === false) {
    return val;
  } else {
    return convertedNum;
  }
};

export {
  isDisplayable,
  isTruthyOrZero,
  parseJsonString,
  isLgLocationById,
  lgLocationIdParts,
  formatName,
  parseName,
  convertNum
};
